import { GridItem } from '@flos/react-ui';

export const FieldBox = ({
    label,
    description,
    children
}: {
    label?: string;
    description?: string;
    children: React.ReactNode;
}): React.JSX.Element => {
    return (
        <>
            <GridItem span={12}>
                <h6 className="u-spacing-stack-none">{label}</h6>
            </GridItem>
            <GridItem span={12}>
                {description && <div className="u-spacing-stack-bottom-2">{description}</div>}
                {children}
            </GridItem>
        </>
    );
};
